import React from "react";
import { observer } from "mobx-react";
import ObWaveform from "../../ObSummary/Tile/ObWaveform";
import Annotations from "../../ObSummary/Tile/Annotations";
import CervicalExams from "../../ObSummary/Tile/CervicalExams";
import ObVitals from "../../ObSummary/Tile/ObVitals";
import Pitocin from "../../ObSummary/Tile/Pitocin";
import ObVitalsExpanded from "../../ObVitalsExpanded";
import ObOther from "../../ObSummary/Tile/ObOther";
import { OB_SUMMARY_TILE_KEYS } from "../../ObSummary/ObSummaryConstants";

const DefaultPanel = observer(function ObDefaultPanel({
  store,
  selectedPatient,
}) {
  return (
    <div className="wave-vitals">
      <ObWaveform
        model={store.waveform}
        summaryStore={store}
        preventZoom={true}
        selectedPatient={selectedPatient}
      />
      {store.tiles.obvitals?.model && (
        <ObVitals model={store.tiles.obvitals.model} />
      )}
    </div>
  );
});
function Panel({ store, selectedPatient }) {
  if (!store.tiles) return null;
  switch (store.selectedPanel) {
    case OB_SUMMARY_TILE_KEYS.MATERNAL_VITALS:
      return <ObVitalsExpanded summaryStore={store} />;
    case OB_SUMMARY_TILE_KEYS.CERVICAL_EXAMS:
      return (
        <CervicalExams
          model={store.tiles.cervicalexams.model}
          expanded={true}
        />
      );
    case OB_SUMMARY_TILE_KEYS.ANNOTATIONS:
      return (
        <Annotations
          model={store.tiles.annotations.model}
          summaryStore={store}
          expanded={true}
        />
      );
    case OB_SUMMARY_TILE_KEYS.PITOCIN:
      return <Pitocin model={store.tiles.pitocin.model} expanded={true} />;
    case OB_SUMMARY_TILE_KEYS.MISC:
      return <ObOther model={store.tiles.other.model} expanded={true} />;
    case OB_SUMMARY_TILE_KEYS.WAVEFORM:
      return <DefaultPanel store={store} selectedPatient={selectedPatient} />;
    default:
      return <DefaultPanel store={store} selectedPatient={selectedPatient} />;
  }
}

const ObSurveilPatientPanel = observer(Panel);
export default ObSurveilPatientPanel;
